import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, PenLine, Phone } from "lucide-react";
import { WHATSAPP_URL } from "@/components/WhatsAppButton";

const MobileActionBar = () => (
  <nav
    className="sm:hidden fixed bottom-0 left-0 right-0 z-50 bg-[rgba(10,10,10,0.92)] backdrop-blur-xl border-t border-[rgba(197,168,128,0.25)]"
    data-testid="mobile-action-bar"
    aria-label="Quick contact"
  >
    <div className="grid grid-cols-3 divide-x divide-[rgba(197,168,128,0.15)]">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp"
        className="flex flex-col items-center gap-1 py-3 text-[#E6CA65]"
      >
        <MessageCircle size={18} />
        <span className="text-[10px] uppercase tracking-[0.15em]">WhatsApp</span>
      </a>
      <Link to="/private-consultation" data-testid="mobile-bar-enquire" className="flex flex-col items-center gap-1 py-3 text-[#F4F3EF]">
        <PenLine size={18} className="text-[#C5A880]" />
        <span className="text-[10px] uppercase tracking-[0.15em]">Enquire</span>
      </Link>
      <a href="tel:+971585862273" data-testid="mobile-bar-call" className="flex flex-col items-center gap-1 py-3 text-[#F4F3EF]">
        <Phone size={18} className="text-[#C5A880]" />
        <span className="text-[10px] uppercase tracking-[0.15em]">Call</span>
      </a>
    </div>
  </nav>
);

export default MobileActionBar;
